import {isTicketBisEvent} from '@stubhub/react-event-helper';

import {getDomainMapping} from './domainMapping';

export default class EventRedirectionUtil {
  /**
   * Default Currency Mapping to be used as the fallback in case the mapping for the currency
   *
   */
  defaultDomainMappingCurrency = getDomainMapping.USD;

  constructor(props) {
    this.data = props;
  }

  /**
   * @private
   * get the Event url, fix the hostname to which the event belongs to
   * @param {Object} event
   * @param {String} redirectionDomain
   * @return {String} url //event url
   */
  getEventUrl = (event, redirectionDomain) => {
    let externalWebURI = event.attributes ? event.attributes.externalWebURI : event.externalWebURI;
    let webURI = event.attributes ? event.attributes.webURI : event.webURI;
    let url = `/${webURI}`;

    if (isTicketBisEvent(event) && externalWebURI) {
      url = redirectionDomain.substring(0, redirectionDomain.length - 1) + externalWebURI;
    }

    return url;
  };

  /**
   * @public
   * determines if current domain and event are within the same domain base on rules api
   * @param {Object} event
   * @param {String} defaultWebTLD
   * @return {Boolean} boolean isSameSite
   */
  sameSite = (event, defaultWebTLD) => {
    if (!event) {
      return true;
    }

    let isSameSite = true;
    let ticketInfo = event.attributes && event.attributes.ticketInfo ? event.attributes.ticketInfo : event.ticketInfo;
    let rulesDomains = this.data && this.data.noredirect && this.data.noredirect.rules;
    let currency = event.currency || event.currencyCode || (ticketInfo && ticketInfo.currencyCode);

    /**
     * Check for Ticketbis Events
     *
     */
    if (isTicketBisEvent(event)) {
      isSameSite = false;
    } else if (rulesDomains && rulesDomains.length) {
      let domainMappingCurrency = getDomainMapping[currency] || this.defaultDomainMappingCurrency || {};
      if (defaultWebTLD !== domainMappingCurrency.site) {
        isSameSite = false;
      }
      rulesDomains.forEach((v) => {
        if (v.tldList.indexOf(defaultWebTLD) > -1 && v.tldList.indexOf(domainMappingCurrency.site) > -1) {
          if (v.eventIdList.indexOf('*') > -1 || v.eventIdList.indexOf(String(event.id)) > -1) {
            isSameSite = true;
          }
        }
      });
    }

    return isSameSite;
  };
}
